import SharedFlightTag from './SharedFlightTag';

export default SharedFlightTag;
